import { render, staticRenderFns } from "./OpenApiDialog.vue?vue&type=template&id=4427855b&scoped=true"
import script from "./OpenApiDialog.vue?vue&type=script&lang=ts"
export * from "./OpenApiDialog.vue?vue&type=script&lang=ts"
import style0 from "./OpenApiDialog.vue?vue&type=style&index=0&id=4427855b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427855b",
  null
  
)

export default component.exports